import React, { useEffect, useState } from 'react'
import { Routes, Route, useNavigate } from 'react-router-dom'
import { _setSelectedCompanyId, affiliateData, company } from './data/AffiliateData'
import { apiURL, setAPIUrl } from './utilities/URLs'
import Navbar from './utilities/Navbar'
import Dashboard from './pages/Dashboard'
import Login from './pages/Login'
import Leads from './pages/Leads'
import Account from './pages/Account'
import RequestPasswordReset from './pages/RequestPasswordReset'
import ResetPassword from './pages/ResetPassword'
import SubAffiliateList from './pages/SubAffiliateList'
import Resources from './pages/Resources'
import Stats from './pages/Stats'
import { ThemeProvider, useTheme } from './ThemeContext'
import { refreshAccessToken } from './utilities/extensions'
import Payments from './pages/Payments'
import Lead from './pages/Lead'

import './css/loader.css'
import './App.css'

function AppContent() {
  const navigate = useNavigate()
  const { isDarkMode } = useTheme()

  const routeNames = ['dashboard', 'leads', 'lead', 'resources', 'account', 'subAffiliateList', 'requestPasswordReset', 'resetPassword', 'statistics', 'payments']

  const [fetchedCompany, setFetchedCompany] = useState(false)
  const [checkingLogin, setCheckingLogin] = useState(true)
  const [loggingInWithAccessToken, setLoggingInWithAccessToken] = useState(false)
  const [loggedIn, setLoggedIn] = useState(false)

  const [activeTab, setActiveTab] = useState('dashboard')
  const [filteredLeadStages, setFilterLeadStages] = useState('')
  const [impersonationMode, setImpersonationMode] = useState(false)

  useEffect(() => {
    const handleGetCompany = async () => {
      const companyResponse = await fetch(`${apiURL}/api/getCompany?companyURL=${encodeURIComponent(window.location.hostname)}`)
      const companyData = await companyResponse.json()
      if(companyData.response.error)
        console.error(companyData.response.error)
      else {
        company.setCompany(companyData.response.company)

        document.title = company.companyName

        let link = document.querySelector("link[rel~='icon']")
        if (!link) {
            link = document.createElement('link')
            link.rel = 'icon'
            document.head.appendChild(link)
        }
        link.href = company.companyFavIconURL

        let link2 = document.querySelector("link[rel~='apple-touch-icon']")
        if (!link2) {
            link2 = document.createElement('link')
            link2.rel = 'apple-touch-icon'
            document.head.appendChild(link)
        }
        link.href2 = company.companyFavIconURL
        
        document.documentElement.style.setProperty('--primary-color', company.companyPrimaryColor)
        document.documentElement.style.setProperty('--primary-dark-color', company.companyPrimaryDarkColor)
        document.documentElement.style.setProperty('--secondary-color', company.companySecondaryColor)
        document.documentElement.style.setProperty('--secondary-dark-color', company.companyPrimaryDarkColor)
        _setSelectedCompanyId(company.companyId === '6243c824-9e29-46da-94c6-96d03d8cbb84' ? '1' : company.companyId)

        setFetchedCompany(true)
      }
    }
    
    setAPIUrl(window.location.hostname)
    handleGetCompany()
  }, [])

  useEffect(() => {
    const handleLoginWithAccessToken = async () => {
      const loginWithAffiliateIdResponse = await fetch(`${apiURL}/api/loginWithJWT`, {
        headers: {
          'Authorization': accessToken
        }
      })
      const loginWithAffiliateIdData = await loginWithAffiliateIdResponse.json()

      if(loginWithAffiliateIdData.response.error) {
        if(loginWithAffiliateIdData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          if(refreshedToken && refreshedToken.length > 0) {
            accessToken = refreshedToken
            await handleLoginWithAccessToken()
          } else {
            setLoggedIn(false)
            setLoggingInWithAccessToken(false)
            navigate('/affiliate', { state: { expired: true }})
          }
        } else {
          console.error(loginWithAffiliateIdData.response.error)
          setLoggedIn(false)
          setLoggingInWithAccessToken(false)
          navigate('/affiliate', { state: { expired: true } })
        }
      } else {
        affiliateData.setAffiliateData(loginWithAffiliateIdData.response)
        affiliateData.accessToken = accessToken
        setLoggingInWithAccessToken(false)
        setLoggedIn(true)
        
        if (parts.length > 2 && parts[parts.length - 1] !== '') {
          navigate(parts[2] == 'leads' ? `/affiliate/leads${window.location.search}` : parts.join('/'))
          setActiveTab(parts[2])
        } else
          navigate('/affiliate/dashboard')
      }
    }

    const handleImpersonateAffiliate = async (affiliateId) => {
      const impersonateAffiliateResponse = await fetch(`${apiURL}/api/impersonateAffiliate?affiliateId=${encodeURIComponent(affiliateId)}`)
      const impersonateAffiliateData = await impersonateAffiliateResponse.json()
      if(impersonateAffiliateData.response.error)
        console.error(impersonateAffiliateData.response.error)
      else {
        affiliateData.setAffiliateData(impersonateAffiliateData.response)
        setLoggingInWithAccessToken(false)
        setLoggedIn(true)
        navigate('/affiliate/dashboard')
      }
    }

    let accessToken = ''
    const url = window.location.pathname
    const parts = url.split('/')

    if(fetchedCompany) {
      if(parts.length > 2 && parts[2] === 'resetPassword')
        navigate(`/affiliate/resetPassword/${parts[3]}`)
      else if(parts.length > 2 && parts[2] && parts[2].length > 0 && !routeNames.includes(parts[2])) {
        setImpersonationMode(true)
        setLoggingInWithAccessToken(true)
        handleImpersonateAffiliate(parts[2])
      } else {
        accessToken = localStorage.getItem('affiliateAccessToken')
        if(accessToken) {
          setLoggingInWithAccessToken(true)
          handleLoginWithAccessToken()
        } 
      }

      setCheckingLogin(false)
    }
  }, [fetchedCompany])

  if(!fetchedCompany)
    return null
  if(checkingLogin)
    return null

  return (
    <>
    {loggingInWithAccessToken ? (
      <div className={`flex flex-col items-center justify-center h-screen font-mont ${isDarkMode && 'bg-[#1a1d21]'}`}>
        <img className='w-60 mb-28' src={company.companyLogoURL} alt='setcLogo' />
        <div className="loader ease-linear rounded-full border-8 border-t-8 h-12 w-12 mb-4"></div>
        <p className={`text-xl ${isDarkMode && 'text-white'}`}>Logging In...</p>
      </div>
    ) : (
      <>
        {loggedIn && (
          <Navbar
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            setFilterLeadStages={setFilterLeadStages}
            impersonationMode={impersonationMode}
          />
        )}
        <Routes>
          <Route path='/affiliate' element={<Login setLoggedIn={setLoggedIn} />} />
          <Route path='/affiliate/dashboard' element={<Dashboard setActiveTab={setActiveTab} setFilteredLeadStages={setFilterLeadStages} />} />
          <Route path='/affiliate/leads' element={<Leads />} />
          <Route path='/affiliate/leads/:leadId' element={<Lead />} />
          <Route path='/affiliate/resources' element={<Resources />} />
          <Route path='/affiliate/account' element={<Account />} />
          <Route path='/affiliate/subAffiliateList' element={<SubAffiliateList />} />
          <Route path='/affiliate/requestPasswordReset' element={<RequestPasswordReset />} />
          <Route path='/affiliate/resetPassword/:token' element={<ResetPassword />} />
          <Route path='/affiliate/statistics' element={<Stats />} />
          <Route path='/affiliate/payments' element={<Payments />} />
        </Routes>
      </>
    )}
      
    </>
  )
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  )
}

export default App